<template>
  <div class="relative">
    <div
      v-if="listItems[0]"
      v-html="initialsOrImage(0)"
      :class="
        'flex items-center justify-center rounded-full bg-white text-indigo-600 border border-indigo-600 text-sm absolute uppercase ' +
        size +
        ' ' +
        (listItems.length == 2
          ? '-left-6'
          : listItems.length == 3
          ? '-left-12'
          : listItems.length > 3
          ? '-left-18'
          : '')
      "
    />
    <div
      v-if="listItems[1]"
      v-html="initialsOrImage(1)"
      :class="
        'flex items-center justify-center rounded-full bg-white text-indigo-600 border border-indigo-600 text-sm absolute uppercase ' +
        size +
        ' ' +
        (listItems.length == 3
          ? '-left-6'
          : listItems.length > 3
          ? '-left-12'
          : '')
      "
    />
    <div
      v-if="listItems[2]"
      v-html="initialsOrImage(2)"
      :class="
        'flex items-center justify-center rounded-full bg-white text-indigo-600 border border-indigo-600 text-sm absolute uppercase ' +
        size +
        ' ' +
        (listItems.length > 3 ? '-left-6' : '')
      "
    />
    <div
      v-if="listItems.length > 3"
      :class="
        size +
        ' flex items-center justify-center rounded-full bg-white text-indigo-600 border border-indigo-600 text-sm absolute'
      "
    >
      +{{ listItems.length - 3 }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    listItems: {
      type: Array,
      required: true,
    },

    libelleFirstname: {
      type: String,
      required: false,
      default: 'firstname',
    },

    libelleLastname: {
      type: String,
      required: false,
      default: 'lastname',
    },

    size: {
      type: String,
      required: false,
      default: 'w-8 h-8',
    },
  },

  methods: {
    initialsOrImage(index) {
      const user = this.listItems[index];
      if (
        !user.profile_image ||
        user.profile_image === null ||
        (typeof user.profile_image === 'string' && user.profile_image === '')
      ) {
        return (
          user[this.libelleFirstname].charAt(0) +
          '' +
          user[this.libelleLastname].charAt()
        );
      }
      return (
        "<img class='rounded-full w-8 h-8 object-cover' src='" +
        user.profile_image +
        "'/>"
      );
    },
  },
};
</script>
